/* Copyright (c) 2020-2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

export const ERROR_TEXT = {
  default: "Something went wrong",
  accessDenied: "Access denied",
} as const;
